import axios, { AxiosResponse } from 'axios';
import { URL_LOGIN, URL_LOGIN_IM } from 'constants/url';
import { LoginRequest } from 'hooks/useUser';

type LoginResponse = {
  accessToken: string;
  email: string;
  firstName: string;
  userName: string;
  roles: [];
  isConfigurationComplete: boolean;
  shopName: string;
};

export default async function loginService(data: LoginRequest): Promise<LoginResponse | null> {
  try {
    console.log(data);

    const result: AxiosResponse = await axios.post(URL_LOGIN, { username: data.username, password: data.password });
    if (result.status === 200 && result.data) {
      const loginResult: LoginResponse = { ...result.data };
      // guardar access_token
      return loginResult;
    }
  } catch (error) {
    const result: AxiosResponse = await axios.post(URL_LOGIN_IM, { username: data.username, password: data.password });
    if (result.status === 200 && result.data) {
      const loginResult: LoginResponse = { ...result.data };
      // guardar access_token
      return loginResult;
    }
  }

  return null; // Consumo al otro endpoint de login
}
